// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Base, Placeholder, FqdnPlaceholder } from '@gandi/ui';

import styles from './PlaceholderRow.scss';

function PlaceholderRow(): React.MixedElement {
  return (
    <Base
      tagName="li"
      backgroundColor="white"
      flex
      className={clsx(styles.root)}
    >
      <Base flex flexGrow1 flexJustifyBetween>
        <FqdnPlaceholder />
      </Base>
      <Base flex flexJustifyEnd flexAlignItemsCenter gap="xsmall">
        <Placeholder chars={10} />
      </Base>
    </Base>
  );
}

export default (React.memo<{}>(
  PlaceholderRow,
  () => true,
): React.ComponentType<{}>);
